import React from 'react';
import { X, User } from 'lucide-react';
import { Child } from '../../store/slices/apiSlice';

interface ProfilePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  child: Child;
}

const ProfilePreviewModal: React.FC<ProfilePreviewModalProps> = ({ isOpen, onClose, child }) => {
  if (!isOpen || !child) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-60 transition-opacity backdrop-blur-sm"
          onClick={onClose}
        ></div>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-white text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
          {/* Card Header */}
          <div className="bg-white px-6 py-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900">Profile Image</h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Card Body */}
          <div className="bg-white p-6">
            {/* Image Container */}
            <div className="relative">
              <div className="bg-gray-100 rounded-xl p-4 shadow-inner">
                {child.profile_image ? (
                  <img
                    src={child.profile_image}
                    alt={child.name}
                    className="w-full h-auto max-h-[500px] object-contain rounded-lg shadow-lg"
                  />
                ) : (
                  <div className="w-full h-96 bg-gray-200 rounded-lg flex items-center justify-center">
                    <User className="w-24 h-24 text-gray-400" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePreviewModal;
